import { render, staticRenderFns } from "./enderecos.vue?vue&type=template&id=a6e3f386"
import script from "./enderecos.vue?vue&type=script&lang=js"
export * from "./enderecos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports